import _ from "lodash";

export const getWantAdDetailMeta = (adDetails, tenant) => {
  const isBLSTenant = !!tenant?.id && tenant.id !== "default";
  const mlsName = isBLSTenant
    ? (tenant?.head?.title || "").replace(/ - Buyer Listing Service$/i, "") ||
      "MLS"
    : "";

  const blsReference = _.get(adDetails, "blsReference", null);

  const postedDate =
    _.get(adDetails, "publishedOn", null) ||
    _.get(adDetails, "createdOn", null);
  const parsedPostedDate = postedDate ? new Date(postedDate) : null;
  const postedLabel =
    parsedPostedDate && !isNaN(parsedPostedDate.getTime())
      ? parsedPostedDate.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "";

  return {
    mlsName,
    blsReference,
    postedLabel,
    hasDetailMetaInfo: !!(mlsName || blsReference || postedLabel),
  };
};

export const getAgentProfileCardBLSInfo = (adDetails, tenant) => {
  return { showBLSInfo: false, blsInfoLine: "" };
};
